interface DashboardFilters {
  pageSize?: number;
  currentPage?: number;
  country?: string;
  seasonIndex?: string | null;
  agronomist?: string[];
  subDistrict?: string[];
  seasonStatus?: string;
  groupType?: string;
  sort?: string;
  plantingGroupName?: string;
}

export const constructDashboardQueryParams = (filters: DashboardFilters) => {
  const {
    pageSize,
    currentPage,
    country,
    seasonIndex,
    agronomist,
    subDistrict,
    seasonStatus,
    groupType,
    sort,
    plantingGroupName,
  } = filters;

  return {
    ...(pageSize && { size: pageSize }),
    ...(currentPage && { page: currentPage - 1 }),
    ...(country && { country }),
    ...(seasonIndex && { seasonTypeId: seasonIndex }),
    ...(agronomist?.length && { agronomist: agronomist.join(',') }),
    ...(subDistrict?.length && { subDistrict: subDistrict.join(',') }),
    ...(seasonStatus && { seasonStatus }),
    ...(groupType && { groupType }),
    ...(!groupType && { groupType: 'FULL_STACK_GROUP,PLANTING_GROUP' }),
    ...(sort && { sort }),
    ...(plantingGroupName && { seasonName: plantingGroupName }),
  };
};
